
import { 
  FloatingFeature 
} from "@models";
import { 
  Limitations, 
  UpgradableNumber 
} from "@dndModels/misc";

/**
 * This gives the character access to some knowledge for use in some fashion.
 */
export class KnowledgeFeature extends FloatingFeature {
  type = ""; // What kind of thing is being learned? For now I'm making it for Adaptation, but I can see it working for Skill, Tool, Language, EldritchInvocation, Spell, CraftingRecipe, Creature, and all kinds of other things.
  usage_key = ""; // What it's used for.  This can generally be ignored, but for some types of Knowledge it may be necessary to lock them behind usage, for example Creature could be used for both Summon and Transform.
  // obj_filter: any = {};
  count: UpgradableNumber = new UpgradableNumber(1);
  limitations: Limitations = new Limitations();

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.type = obj.type ? obj.type : "";
      this.usage_key = obj.usage_key ? obj.usage_key : (obj.usage ? obj.usage : "");
      // this.obj_filter = obj.obj_filter ? obj.obj_filter : {};
      this.count = obj.count ? new UpgradableNumber(obj.count) : new UpgradableNumber(1);
      if (this.type === "Spell" || this.type === "Creature") {
        if (!obj.limitations) {
          obj.limitations = {};
        }
        obj.limitations.limitation_type = "Creature";
        for (const limit of this.limitations.limits) {
          limit.limitation_type = "Creature";
        }
      }
      this.limitations = obj.limitations ? new Limitations(obj.limitations) : new Limitations();
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.type = obj.type ? obj.type : "";
  //     this.usage_key = obj.usage_key ? obj.usage_key : (obj.usage ? obj.usage : "");
  //     // this.obj_filter = obj.obj_filter ? obj.obj_filter : {};
  //     this.count = obj.count ? new UpgradableNumber(obj.count) : new UpgradableNumber(1);
  //     if (this.type === "Spell" || this.type === "Creature") {
  //       if (!obj.limitations) {
  //         obj.limitations = {};
  //       }
  //       obj.limitations.limitation_type = "Creature";
  //       for (const limit of this.limitations.limits) {
  //         limit.limitation_type = "Creature";
  //       }
  //     }
  //     this.limitations = obj.limitations ? new Limitations(obj.limitations) : new Limitations();
  //   }
  // }

  toDBObj(): any {
    const super_obj = super.toDBObj();
    return {
      ...super_obj,
      type: this.type,
      usage_key: this.usage_key,
      // obj_filter: this.obj_filter,
      count: this.count.toDBObj(),
      limitations: this.limitations.toDBObj()
    };
  }

  clone(drop_ids = false): KnowledgeFeature {
    const clone = new KnowledgeFeature();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof KnowledgeFeature) {
      this.type = copyMe.type;
      this.usage_key = copyMe.usage_key;
      // this.obj_filter = {...copyMe.obj_filter};
      this.count = copyMe.count.clone();
      this.limitations = copyMe.limitations.clone(drop_ids);
    }
  }
}

/**
 * This gives the character the ability to learn knowledge for use in some fashion, 
 * without the need to gain each piece of knowledge through a feature.  
 * 
 * Instead this allows the user to add knowledge through the knowledge modal,
 * accessible through the book icon I'm going to put next to the bed icon for rests.
 */
export class LearnableFeature extends FloatingFeature {
  type = ""; // What kind of thing is being learned? For now I'm making it for Adaptation, but I can see it working for Skill, Tool, Language, EldritchInvocation, Spell, CraftingRecipe, Creature, and all kinds of other things.
  usage_key = ""; // What it's used for.  This can generally be ignored, but for some types of Knowledge it may be necessary to lock them behind usage, for example Creature could be used for both Summon and Transform.
  obj_filter: any = {}; // These are the only ones that are learnable sans KnowledgeFeature.

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.type = obj.type ? obj.type : "";
      this.usage_key = obj.usage_key ? obj.usage_key : (obj.usage ? obj.usage : "");
      this.obj_filter = obj.obj_filter ? obj.obj_filter : {};
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.type = obj.type ? obj.type : "";
  //     this.usage_key = obj.usage_key ? obj.usage_key : (obj.usage ? obj.usage : "");
  //     this.obj_filter = obj.obj_filter ? obj.obj_filter : {};
  //   }
  // }

  toDBObj(): any {
    const super_obj = super.toDBObj();
    return {
      ...super_obj,
      type: this.type,
      usage_key: this.usage_key,
      obj_filter: this.obj_filter,
    };
  }

  clone(drop_ids = false): LearnableFeature {
    const clone = new LearnableFeature();
    clone.copy(this, drop_ids);
    return clone;
  }

  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof LearnableFeature) {
      this.type = copyMe.type;
      this.usage_key = copyMe.usage_key;
      this.obj_filter = {...copyMe.obj_filter};
    }
  }
}
